<template>
  <div class="BatchBox">
    <div class="BatchBoxFirst">
      <span v-html="title"></span>
      <span>（{{data.length}}）</span>
    </div>
    <div class="BatchBoxSecond ovy-a">
      <div class="BatchforBox">
        <div class="BatchforFlex" v-for="(item,index) in data">
          <div class="BatchImgBox">
            <img @click="remove(index)"  @mouseover="mouseOver" @mouseleave="mouseLeave"  style="width: 16px;" :src="cancelSelectionImg.mouseLeave" >
          </div>
          <span style="padding-left: 5px;" v-html="item[props.label]"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "batchBox",
  props: {
    props: {
      type: Object,
      default: () => {
        return {
          value: 'id',      // ID字段名
          label: 'text',   // 显示名称
        }
      }
    },
    title:  {
      type: String,
      default: () => {
        return '选中数据';
      }
    },
  },
  data() {
    return {
      data: [],
      cancelSelectionImg: {
        mouseOver: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAgVBMVEUAAADiAADeAADjAADiAADiAADjAADiAADjAADiAADjAADjAADgAADjAADiAADiAADiAADiAADiAADlAADiAADjAADjAADkAADiAADiAADiAADiAADiAADjAADhAADjAADiAADiAADlAADiAADhAADhAADgAADqAADiAADjAADiAAD75U2oAAAAKnRSTlMA9A/F+T0b4o/v134f69KdrKJgE9t0Uxb95Lmli3YzL2pLJ7BuZigMy710+eSRAAABfElEQVQ4y52V63KCMBBGN4Agd1AsKuC11fZ7/wfsGAQ2JAWm51/gJLPZye7SiNtXanv+Hv7Bzj9PNEEZBlDwwi2ZcVMHGqK2TO5OwEi80dTtEX+SjQ6PAkyQuEq4HibxmG0lmCEoeznDLMfO3WABzTuIGAtwIinXWEQqMyywCOeVkRADd7dM2e/L88zyHxIRW+IV17p3P9TLF0Q3MFyS9uByGSe6qJeQ9uBa3xjYUQ7OurV71wajIhsm2+TCJg8m+2xwcSAfJtvkwqc9dJu7HIPsnNsyw5i9Hoa4UksOLYzD+MuKOu5Q8capi2UMq3bHD0apq9TND+kKIe2nelKu3qOIWheQ9qg4L3TiMbid29kur6IHUYGerHMHO2MVrj7+5O0yO1Efv+uwK1wbwTLeXCu2kg01xSLqts85WEBskaTBAvrGe8Qs2TAeCsyQWP9ouZIowQRBRApWNtFu9ZG1iWFE7MiAVQtoOHlEZrbjoVmEJTHM4xivcVxp4/gXQfjV2hsc2P4AAAAASUVORK5CYII=',
        mouseLeave: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAOVBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzq6ur////39/e0D/LWAAAAD3RSTlMA+PDUVUiGu7KpIwuEmJRSzntKAAAA2ElEQVQ4y4zQSxKDIBBF0f7IT0yecf+LTTKIYroF74ziFPUK+quGmFWYRXMMlXqFwmjiEi7ppDDp5NI5wS3NzrOCi8Q8vqDTcrZPdHu0NmJQbPZi2L57ljGW358k3CiZEeMheg/r1wYcbesZrBuOwgeX9vK1a3ssRJXNtW/BdV/RAN8CgSKs9i0iZVjtW2RSONq1UBJ42rMQYnjas+B3ZXVOAAAAAjHMv+toyM7Ac7RVXG3UgLW6Okqdu4I0Ea3wz1vVww4KCjKDrwHjIHdgPpoYAbXaXpqlY02MV7dDb7ytAAAAAElFTkSuQmCC'
      }
    }
  },
  methods: {
    // 移入
    mouseOver($event) {
      $event.target.src = this.cancelSelectionImg.mouseOver;
    },
    // 移出
    mouseLeave($event) {
      $event.target.src = this.cancelSelectionImg.mouseLeave;
    },
    //set data
    setSelection(data){
      this.data = data;
    },
    // clear all
    clearAll(){
      this.data = [];
    },
    //remove data
    remove(index) {
      let oldData = this.data[index];
      this.data.splice(index,  1);
      this.$emit("selection-change", this.data);
      this.$emit("selection-change-remove", oldData, this.data);
    }
  }
}
</script>

<style scoped>
.BatchBox {
  margin-top: 62px;
  display: flex;
  height: 60px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(235, 238, 245);
  border-image: initial;
  border-radius: 5px;
}

.BatchBoxFirst  {
  width: 260px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(242, 247, 253);
}

.BatchBoxSecond {
  width: 100%;
}

.ovy-a {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 0px 1rem;
}


.BatchforBox {
  display: flex;
  flex-wrap: wrap;
}

.BatchforFlex {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 20px;
}
.BatchImgBox {

  display: flex;
  justify-content: center;
  align-items: center;
}


.tree-div {
  overflow-y: auto;
  height: auto;
  height: 330px;
  overflow-x: hidden;
}


.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  line-height: 28px;
  overflow: hidden;
  overflow-y: auto;
}

.el-select-dropdown__item.selected {
  font-weight: normal;
}

ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}

.el-tree-node__label {
  font-weight: normal;
}

.el-tree >>> .is-current .el-tree-node__label {
  color: #5D8C82;
  font-weight: 700;
}

.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-button {
  display: none;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}


::-webkit-scrollbar-thumb {
  background-color: #93c7f5;
  border-radius: 9px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-track-piece {
  background: linear-gradient(90deg, #d8d9de, #e6e8ec);
  background: -webkit-linear-gradient(90deg, #d8d9de, #e6e8ec);
  border-radius: 9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/batchBox.vue